import { useState, useCallback } from "react";

export interface Settings {
  /**
   * No longer used for sizing (2026-10-05): account size, risk per trade and
   * the daily limits live in the desk's server config (Settings › Account,
   * /api/day-risk/config), so the ticket, the desk and the safety limit agree.
   */
  accountSize: number;
  riskPercent: number;
  /** No longer used: the desk scans today's coins only, the same list as the Telegram scanner. */
  customCoins: string[];
  minScore: number;
  minRR: number;
  btcCorrelationFilter: boolean;
  macroContextFilter: boolean;
  heatCap: number;
  groupCap: number;
}

const STORAGE_KEY = "vknow_settings";

const DEFAULTS: Settings = {
  accountSize: 500,
  riskPercent: 1,
  customCoins: [],
  minScore: 65,
  minRR: 2.0,
  btcCorrelationFilter: true,
  macroContextFilter: true,
  heatCap: 5,
  groupCap: 3,
};

function load(): Settings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export function useSettings() {
  const [settings, setSettingsState] = useState<Settings>(load);

  const updateSettings = useCallback((patch: Partial<Settings>) => {
    setSettingsState((prev) => {
      const next = { ...prev, ...patch };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { settings, updateSettings };
}
